import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-distance-courses',
  templateUrl: './distance-courses.component.html',
  styleUrls: ['./distance-courses.component.scss']
})
export class DistanceCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
